import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LocalStorageService } from 'src/app/services/localstorage.service';
import { VariablesService } from 'src/app/services/variableGL.service';

@Injectable({
  providedIn: 'root'
})
export class CierreSesion {

  private timeoutId: any;
 
  private readonly timeout = 10 * 60 * 1000;

  private readonly events = ['mousemove', 'keydown', 'scroll', 'click'];

  private readonly resetTimerFn = this.resetTimer.bind(this);

  constructor(
    private router: Router,
    private localStorageService: LocalStorageService,
    private ngZone: NgZone,
    private variablesService: VariablesService,
    private modalService: NgbModal
  ) {}

  startWatching(): void {
    this.resetTimer();

    this.events.forEach(event =>
      window.addEventListener(event, this.resetTimerFn)
    );
  }

  stopWatching(): void {
    this.events.forEach(event =>
      window.removeEventListener(event, this.resetTimerFn)
    );
    clearTimeout(this.timeoutId);
  }

  private resetTimer(): void {
    clearTimeout(this.timeoutId);
    this.timeoutId = setTimeout(() => {
      this.ngZone.run(() => this.logout());
    }, this.timeout);
  }

  logout(): void {
    this.stopWatching();
    this.cerrarModales();
    this.limpiarStorage();

    this.variablesService.toastInfo(
      'La sesión se ha cerrado por inactividad.'
    );
    this.router.navigate(['auth/signin'], { replaceUrl: true });
  }

  private cerrarModales(): void {
    this.modalService.dismissAll();

    document.body.classList.remove('modal-open');
    document.querySelectorAll('.modal-backdrop').forEach(b => b.remove());
  }

  private limpiarStorage(): void {
    localStorage.clear();
  }

  private async limpiarCache(): Promise<void> {
    try {
      if ('caches' in window) {
        const keys = await caches.keys();
        await Promise.all(keys.map(k => caches.delete(k)));
      }

      if ('serviceWorker' in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations();
        await Promise.all(registrations.map(r => r.unregister()));
      }
    } catch (error) {
      console.error('Error limpiando cache:', error);
    }
  }
}
